import { DeErrorBoundary } from '@components/error/DeErrorBoundary';
import React, { ReactNode, Suspense } from 'react';
import { AngularReady } from '../ng/AngularReady';
import { Loading } from '@components/loading';

export type RoutesWrapProps = {
    children: ReactNode;
};

export function RoutesWrap({ children }: RoutesWrapProps) {
    return (
        <DeErrorBoundary>
            <AngularReady fallback={<Loading global={true} />}>
                <Suspense fallback={<Loading global={true} />}>{children}</Suspense>
            </AngularReady>
        </DeErrorBoundary>
    );
}
